<template>
    <div id="isAuthenticated" class="m-box-shadow" v-if="!isAuthenticated">

        <div class="block">

            You have been logged out due to inactivity <br>
            <span>Page will be automatically refreshed after 30 seconds</span><br><br>
            <a class="btn btn-success" href="javascript:;" @click="reload()">Click here to log in again</a>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            dataApi: {
                type: Function,
                required: true
            },

        },


        data() {
            return {
                isAuthenticated: true
            }
        },
        methods: {
            reload() {
                location.reload(true)
            }
        },

        watch: {
            isAuthenticated(newV) {
                if (!newV) {
                    var self = this
                    setTimeout(function () {
                        console.log('should fire')
                        self.reload()
                    }, 30000)
                }
            }
        },
        created() {
            var self = this
            this.dataApi.interceptors.response.use(function (response) {
                // Do something with response data
                if (response.status == 401) {
                    self.isAuthenticated = !self.isAuthenticated
                    // location.reload(true)
                }
                return response;
            }, function (error) {
                if (error.response.status == 401) {
                    self.isAuthenticated = !self.isAuthenticated
                    // location.reload(true)
                }
                // Do something with response error
                return Promise.reject(error);
            });
        }
    }
</script>
<style scoped lang="scss">
    #isAuthenticated {
        top: 0;
        left: 0;
        z-index: 2000;
        width: 100%;
        position: fixed;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);

        span {
            opacity: 0.3
        }

        .block {
            text-align: center;
            color: black;
            background: white;
            position: fixed;
            top: 50%;
            left: 50%;
            /* bring your own prefixes */
            transform: translate(-50%, -50%);
            padding: 50px;

        }
    }

</style>